import Flags from './Flags.jsx';

export default Flags;